import { ListingEditorViewModel } from "@lumora/core";
import { SITE, client } from "../client.js";
import Car from "../models/Car.js";
import { legacyCarToListingInput, listingToLegacyCar, listingsToLegacyCars } from "./listingMap.js";

/** Shared staff listing editor; Views read cars through the helpers below. */
export const stock = new ListingEditorViewModel(client, SITE);

/** Cars for the lot, or null when the API call failed (callers keep their old list). */
export async function loadCars(): Promise<Car[] | null> {
  const rows = await stock.load();
  if (stock.state.error) return null;
  return listingsToLegacyCars(rows).map((c) => new Car(c));
}

export function carFromListing(listing: Parameters<typeof listingToLegacyCar>[0]): Car {
  return new Car(listingToLegacyCar(listing));
}

/** Save the editable fields of a Car; VIN and id stay as stored. */
export async function saveCar(car: Car): Promise<Car | null> {
  const { id: _id, vin: _vin, ...patch } = legacyCarToListingInput({ ...car, investors: [] });
  const row = await stock.save(car.id, patch);
  return row ? carFromListing(row) : null;
}
